import React from 'react'
import SpeedTest from '../components/SpeedTest'

const Home: React.FC = () => {
  return <SpeedTest />
}

export default Home




